import { masterfieldUrl } from '../global_constants';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SurveyService } from '../rest_services/msSurveyServices/survey.service';
import { VisitService } from '../rest_services/visit.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-wam-custom-survey',
  templateUrl: './wam-custom-survey.component.html',
  styleUrls: ['./wam-custom-survey.component.css']
})
export class WamCustomSurveyComponent implements OnInit, OnDestroy {
  masterfieldUrl = masterfieldUrl;
  currentDate: Date = new Date();
  satisfactionForm!: FormGroup;
  uuid: any;
  loading: boolean = true;
  loadingSending: boolean = false;
  isSubmitting: boolean = false;
  questions: any[] = [];
  alreadyResponded: boolean = false;
  customerAnswers: any[] = [];
  clientName: string = '';
  visitUuid: any;
  
  // Ajoutez cette propriété pour gérer les abonnements
  private subscriptions: Subscription = new Subscription();
  
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private surveyService: SurveyService,
    private visitService: VisitService,
  ) {}

  ngOnInit(): void {
    this.currentDate = new Date();
    this.uuid = this.route.snapshot.params['id'];
    this.getSurvey();
    
    const link = document.querySelector('link[href*="cloud-bundle.min.css"]');
    link?.remove();
  }

  ngOnDestroy(): void {
    // Désabonner toutes les souscriptions
    this.subscriptions.unsubscribe();
  }

  getSurvey(): void {
    this.surveyService.getSurveyForClient(this.uuid);
    const surveySub = this.surveyService.surveyClientSubject.subscribe(
      (data: any) => {
        if (data.status == '200') {
          this.loading = false;
          
          if (data.survey.surveyStatus == "responded") {
            this.alreadyResponded = true;
          }
          
          this.questions = data.survey.questions;
          this.visitUuid = data.survey.visitUuid;
          this.getCustomerRSByVisitUuid(this.visitUuid);
          this.initForm();
        }
      },
      (error: any) => {
        this.loading = false;
      }
    );
    this.subscriptions.add(surveySub);
  }

  customerRs: any = '';
  logo: any = null;
  
  getCustomerRSByVisitUuid(id: any) {
    this.visitService.getCustomerByVisit(id, ['id', 'customer', 'logo']);
    const customerSub = this.visitService.detailSubject.subscribe(
      (data: any) => {
        if (data.code == "9ee6b80261f5935fcdc9848ac558b605") {
          this.customerRs = data.visit.visit_customer;
          this.logo = data.visit.visit_customer_logo;
        }
      }
    );
    this.subscriptions.add(customerSub);
  }

  initForm(): void {
    this.satisfactionForm = this.fb.group({});

    this.questions.forEach((question, index) => {
      if (question.type === 'ch') {
        this.satisfactionForm.addControl(`question_${index}`, 
          this.fb.control('', [Validators.required]));
      } else if (question.type === 'fr') {
        this.satisfactionForm.addControl(`question_${index}`, 
          this.fb.control(''));
      }
    });

    this.satisfactionForm.addControl('rempliPar', 
      this.fb.control('', [Validators.required]));
    this.satisfactionForm.addControl('fonction', 
      this.fb.control(''));
    this.satisfactionForm.addControl('date', 
      this.fb.control(this.currentDate.toLocaleDateString(), [Validators.required]));
    this.satisfactionForm.addControl('visa', 
      this.fb.control(''));
  }

  onCheckboxChange(questionIndex: number, value: string): void {
    this.satisfactionForm.patchValue({ [`question_${questionIndex}`]: value });
  }

  onSubmit(): void {
    // Empêcher la double soumission
    if (this.isSubmitting || this.loadingSending || !this.satisfactionForm.valid) {
      console.log('Formulaire non valide ou déjà en cours de soumission');
      return;
    }
    
    // Marquer comme en cours de soumission
    this.isSubmitting = true;
    this.loadingSending = true;
    
    // Préparer les réponses des questions
    const responses: any[] = [];
    this.questions.forEach((question, index) => {
      if (question.type !== 'fr') {
        responses.push({
          qst_uuid: question.qst_uuid,
          response: this.satisfactionForm.get(`question_${index}`)?.value
        });
      }
    });

    // Ajouter la suggestion
    const suggestionQuestion = this.questions.find(q => q.type === 'fr');
    if (suggestionQuestion) {
      const suggestionIndex = this.questions.findIndex(q => q.type === 'fr');
      responses.push({
        qst_uuid: suggestionQuestion.qst_uuid,
        response: this.satisfactionForm.get(`question_${suggestionIndex}`)?.value || ''
      });
    }

    const responderInfo = {
        filledBy: this.satisfactionForm.get('rempliPar')?.value || '',
        function: this.satisfactionForm.get('fonction')?.value || '',
        fillDate: this.satisfactionForm.get('date')?.value || '',
        visa: this.satisfactionForm.get('visa')?.value || ''
    };

    const requestBody = {
        survey_visit_uuid: this.uuid,
        resp: responses,
        responderInfo: responderInfo // Ajouter les infos du répondant
    };

    console.log('Envoi des données:', requestBody);

    // Appel unique à sendResponse et gestion de la réponse
    const sendSub = this.surveyService.sendResponse(requestBody).subscribe(
      (data: any) => {
        console.log('Réponse reçue:', data);
        this.loadingSending = false;
        this.isSubmitting = false;
        
        if (data.message == "Response to Survey visit sent successfully") {
          this.alreadyResponded = true;
        } else {
          console.error('Erreur lors de l\'envoi:', data);
          (<any>$("#error")).modal('show');
        }
      },
      (error: any) => {
        console.error('Erreur HTTP:', error);
        this.loadingSending = false;
        this.isSubmitting = false;
        (<any>$("#error")).modal('show');
      }
    );
    
    this.subscriptions.add(sendSub);
  }

  hasAtLeastOneResponse(): boolean {
    let hasResponse = false;
    
    this.questions.forEach((question, index) => {
      if (question.type === 'ch') {
        const value = this.satisfactionForm.get(`question_${index}`)?.value;
        if (value && value !== '') {
          hasResponse = true;
        }
      }
    });
    
    const satisfactionValue = this.satisfactionForm.get(`question_9`)?.value;
    if (satisfactionValue && satisfactionValue !== '') {
      hasResponse = true;
    }
    
    const rempliParValue = this.satisfactionForm.get('rempliPar')?.value;
    if (!rempliParValue || rempliParValue.trim() === '') {
      return false;
    }
    
    return hasResponse;
  }

  resetForm(): void {
    if (this.isSubmitting || this.loadingSending) {
      return;
    }
    
    this.satisfactionForm.reset();
    this.satisfactionForm.patchValue({
      date: this.currentDate.toLocaleDateString()
    });
  }
}